import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'lib-question-answer-validation-indicator',
    templateUrl: './question-answer-validation-indicator.component.html',
    styleUrls: ['./question-answer-validation-indicator.component.scss'],
    standalone: false
})
export class QuestionAnswerValidationIndicatorComponent {
  @Input() public set correct(value: boolean) {
    this.isCorrect = value;
    this.isVisible = false;

    setTimeout(() => {
      this.isVisible = true;
    }, 100);
  }

  public isCorrect = false;

  public isVisible = false;

  constructor() { }

  ngOnInit(): void {
  }

}
